/* eslint-disable */
(function(para) {
  var p = para.sdk_url, n = para.name, w = window, d = document, s = 'script',x = null,y = null;
  w['sensorsDataAnalytic201505'] = n;
  w[n] = w[n] || function(a) {return function() {(w[n]._q = w[n]._q || []).push([a, arguments]);}};
  var ifs = ['track','quick','register','registerPage','registerOnce','trackSignup', 'trackAbtest', 'setProfile','setOnceProfile','appendProfile', 'incrementProfile', 'deleteProfile', 'unsetProfile', 'identify','login','logout','trackLink','clearAllRegister','getAppStatus'];
  for (var i = 0; i < ifs.length; i++) {
    w[n][ifs[i]] = w[n].call(null, ifs[i]);
  }
  if (!w[n]._t) {
    x = d.createElement(s), y = d.getElementsByTagName(s)[0];
    x.async = 1;
    x.src = p;
    x.setAttribute('charset','UTF-8');
    y.parentNode.insertBefore(x, y);
    w[n].para = para;
  }
})({
  sdk_url: '//sh1.shihuocdn.cn/js/shence/sa-sdk-javascript/sensorsdata.min.js',
  heatmap_url: '//sh1.shihuocdn.cn/js/shence/sa-sdk-javascript/heatmap.min.js',
  name: 'sa',
  web_url: '//shence-backend.hupu.com/?project=shihuo',
  server_url: '//shence.shihuo.cn/sa?project=shihuo',
  heatmap:{}
});

sa.quick('autoTrack');


// WEBPACK FOOTER //
// ./utils/sa.js